import { render } from "./CreditsMobile.vue?vue&type=template&id=45420d68&scoped=true"
import script from "./CreditsMobile.vue?vue&type=script&lang=js"
export * from "./CreditsMobile.vue?vue&type=script&lang=js"

import "./CreditsMobile.vue?vue&type=style&index=0&id=45420d68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45420d68"]])

export default __exports__